<template>
  <div class="p" :class="{ greska: !!greska, upozorenje: !!upozorenje, izm: izmijenjeno, izr: izracun }" :data-polje="ime">
    <label class="ol">
      {{ label }}<i v-if="obavezno">*</i>
      <span v-if="$slots.akcija" class="akcija"><slot name="akcija"></slot></span>
    </label>
    <slot></slot>
    <div v-if="greska" class="gr">{{ greska }}</div>
    <div v-else-if="upozorenje" class="up">{{ upozorenje }}</div>
    <slot name="info"></slot>
    <div v-if="hint && !greska" class="pomoc">{{ hint }}</div>
  </div>
</template>

<script>
// Redak polja: oznaka, zvjezdica (obavezno), hint, poruka greške / upozorenja, označeno izmijenjeno,
// "= računa se" za izračunata polja (izracun). Stanje čita iz FormaOkvir prema `ime` (ključ polja u modelu).
// U zadani slot ide pravi unos (input/select/textarea ili v-autocomplete) s v-model.
export default {
  name: 'FormaPolje',
  inject: { okvir: { default: null } },
  props: {
    ime: { type: String, default: '' },
    label: { type: String, default: '' },
    obavezno: { type: Boolean, default: false },
    hint: { type: String, default: '' },
    izracun: { type: Boolean, default: false }
  },
  computed: {
    greska () { return this.okvir && this.ime ? this.okvir.greske[this.ime] || '' : '' },
    upozorenje () { return this.okvir && this.ime ? this.okvir.upozorenja[this.ime] || '' : '' },
    izmijenjeno () { return !!(this.okvir && this.ime && this.okvir.izmijenjena.indexOf(this.ime) >= 0) }
  }
}
</script>
